export default __webpack_public_path__ + "btn-del.png?c9e371189395fb3085ec281cc2342a5c";